//@flow
import React from 'react';
import SummarySubSection from './SummarySubSection/SummarySubSection';
import ExchangeRateSection from './ExchangeRateSection/ExchangeRateSection';
import * as chunk from 'lodash.chunk';
import s from './SummarySubSections.less';

type Props = {
  SummarySectionData: Object,
  totalFob: number,
};

const SummarySubSections = (props: Props) => {
  return (
    <div className={`row`}>
      {props.SummarySectionData &&
        chunk (Object.keys (props.SummarySectionData), 3).map (chunk => (
          <div className={`row ${s.subSectionWrapper}`} key={chunk[0]}>
            {chunk.map ((summaryType, index) => {
              return (
                <SummarySubSection
                  key={summaryType}
                  data={props.SummarySectionData[summaryType]}
                  title={summaryType}
                  totalFob={props.totalFob}
                />
              );
            })}
          </div>
        ))}
      <div className={`row ${s.subSectionWrapper}`}>
        <div className={`col-xs-12`}>
          <ExchangeRateSection />
        </div>
      </div>
    </div>
  );
};

export default SummarySubSections;



// WEBPACK FOOTER //
// ./src/components/SummarySubSections/SummarySubSections.js